import { UsersServiceInterface } from 'domain/services';
import {
  GetListProfileUseCaseInterface,
  GetUsersOnlineInterface,
  GetUsersOnlineMapsInterface,
  UpdateStatusAssociatePersonProfileInterface,
} from 'domain/usecases';

export class UsersService implements UsersServiceInterface {
  constructor(
    private readonly _getListProfileUseCase: GetListProfileUseCaseInterface,
    private readonly _getUsersOnline: GetUsersOnlineInterface,
    private readonly _getUsersOnlineMaps: GetUsersOnlineMapsInterface,
    private readonly _updateStatusAssociatePersonProfile: UpdateStatusAssociatePersonProfileInterface,
  ) {}

  async getListProfile(
    params?: GetListProfileUseCaseInterface.Params,
  ): Promise<GetListProfileUseCaseInterface.Result> {
    return await this._getListProfileUseCase.execute(params);
  }

  getUsersOnline(
    params: GetUsersOnlineInterface.Params,
  ): Promise<GetUsersOnlineInterface.Result> {
    return this._getUsersOnline.execute(params);
  }

  getUsersOnlineMaps(
    params: GetUsersOnlineMapsInterface.Params,
  ): Promise<GetUsersOnlineMapsInterface.Result> {
    return this._getUsersOnlineMaps.execute(params);
  }

  updateStatusAssociatePersonProfile(
    params: UpdateStatusAssociatePersonProfileInterface.Params,
  ): Promise<UpdateStatusAssociatePersonProfileInterface.Result> {
    return this._updateStatusAssociatePersonProfile.execute(params);
  }
}
